export default {
  title: {
    id: 'bo_seller.kyb.beneficial_owner.title',
    defaultMessage: 'Primary beneficial owner details',
  },
  description: {
    id: 'bo_seller.kyb.beneficial_owner.description',
    defaultMessage:
      "Fill out details for the business's primary beneficial owner or the majority shareholder. If the majority shareholder is a business, add the director, CEO, or CFO of that business. You can add up to 5 beneficial owners if you want to include additional owners.",
  },
  primaryBeneficialOwner: {
    id: 'bo_seller.kyb.beneficial_owner.primary_beneficial_owner',
    defaultMessage: 'Primary beneficial owner',
  },
  sameAsAccountRequesterLabel: {
    id: 'bo_seller.kyb.beneficial_owner.same_as_account_requester',
    defaultMessage:
      'Check this box if the primary beneficial owner is also the account requester.',
  },
  sameAsLegalRepresentativeLabel: {
    id: 'bo_seller.kyb.beneficial_owner.same_as_legal_representative',
    defaultMessage:
      'Check this box if the primary beneficial owner is also the legal representative.',
  },
  additionalBeneficialOwner: {
    id: 'bo_seller.kyb.beneficial_owner.additional_beneficial_owner',
    defaultMessage: 'Additional beneficial owner',
  },
  addBeneficialOwner: {
    id: 'bo_seller.kyb.beneficial_owner.add_beneficial_owner',
    defaultMessage: 'Add beneficial owner',
  },
  removeBeneficialOwner: {
    id: 'bo_seller.kyb.beneficial_owner.remove_beneficial_owner',
    defaultMessage: 'Remove',
  },
  saveButton: {
    id: 'bo_seller.kyb.beneficial_owner.save_button',
    defaultMessage: 'Save',
  },
} as const
